import { useRef, useState } from 'react';
import { CANVAS_SIZE, type CardEdit } from '@str/shared';
import { PictureStage } from '@/components/composer/PictureStage';

/** The preview is the editing surface; only the delivery asset is flattened. */
export function InlinePicture({
  edit,
  onSave,
  busy,
}: {
  edit: CardEdit;
  onSave: (edit: CardEdit) => Promise<void>;
  busy: boolean;
}) {
  const [value, setValue] = useState(edit);
  const latest = useRef(edit);
  const [selected, setSelected] = useState<string | null>(null);
  const [editing, setEditing] = useState<string | null>(null);
  const dirty = useRef(false);
  const size = CANVAS_SIZE[edit.canvas];
  const save = () => {
    if (!dirty.current) return;
    dirty.current = false;
    void onSave(latest.current).catch(() => {
      dirty.current = true;
    });
  };
  return (
    <div
      className="nx-editor-stage"
      style={{ width: '100%', aspectRatio: `${size.width}/${size.height}` }}
    >
      <PictureStage
        edit={value}
        tool="Adjust"
        selected={selected}
        onSelect={setSelected}
        editing={editing}
        onEditing={(id) => {
          setEditing(id);
          if (!id) save();
        }}
        onChange={(next) => {
          latest.current = next;
          setValue(next);
          dirty.current = true;
          if (!editing) save();
        }}
        color="#ffffff"
        strokeWidth={0.012}
        disabled={busy}
        finishTextOnBlur
      />
    </div>
  );
}
